import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";

const BOT_USERNAME = import.meta.env.VITE_BOT_USERNAME || "mnpclientbot";
const API_BASE = import.meta.env.VITE_API_BASE || "";

export function LoginScreen() {
  const ref = useRef<HTMLDivElement>(null);
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const err = params.get("error");
    if (err === "forbidden") setError("Этот Telegram-аккаунт не в списке операторов.");
    else if (err === "unauthorized") setError("Не удалось проверить подпись Telegram. Попробуйте ещё раз.");
    else if (err) setError(`Ошибка входа: ${err}`);
  }, [params]);

  useEffect(() => {
    if (!ref.current) return;
    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?22";
    script.async = true;
    script.setAttribute("data-telegram-login", BOT_USERNAME);
    script.setAttribute("data-size", "large");
    script.setAttribute("data-radius", "8");
    script.setAttribute("data-auth-url", `${API_BASE}/api/v1/admin/auth/login`);
    script.setAttribute("data-request-access", "write");
    ref.current.appendChild(script);
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 px-4">
      <div className="text-center">
        <h1 className="text-2xl font-semibold">Mark & Post — Ops</h1>
        <p className="text-neutral-400 mt-2">Вход только для операторов</p>
      </div>
      <div ref={ref} />
      {error && <p className="text-sm text-red-400 max-w-sm text-center">{error}</p>}
      <p className="text-xs text-neutral-500 max-w-sm text-center">
        Если виджет не появился — убедитесь, что в @BotFather у бота указан
        домен <code>{window.location.host}</code> через команду <code>/setdomain</code>.
      </p>
    </div>
  );
}
